import { Button, Popconfirm } from 'antd';

interface CatalogueRow {
  name: string;
  isActive: boolean;
}

interface CatalogueRowActionsProps<T extends CatalogueRow> {
  row: T;
  onEdit: (row: T) => void;
  onDeactivate: (row: T) => Promise<void>;
  onReactivate: (row: T) => Promise<void>;
}

/**
 * Edit / Deactivate / Reactivate for a catalogue row — one component shared by
 * all three reference-data panels, since the three copies would be identical
 * but for the type name (same weight as UserRowActions, minus the
 * self-deactivation case, which doesn't apply to configuration rows).
 */
export function CatalogueRowActions<T extends CatalogueRow>({ row, onEdit, onDeactivate, onReactivate }: CatalogueRowActionsProps<T>) {
  return (
    <div className="flex gap-2">
      <Button size="small" onClick={() => onEdit(row)}>
        Edit
      </Button>
      {row.isActive ? (
        <Popconfirm title={`Deactivate ${row.name}?`} onConfirm={() => onDeactivate(row)}>
          <Button danger size="small">
            Deactivate
          </Button>
        </Popconfirm>
      ) : (
        <Popconfirm title={`Reactivate ${row.name}?`} onConfirm={() => onReactivate(row)}>
          <Button size="small">Reactivate</Button>
        </Popconfirm>
      )}
    </div>
  );
}
